import { Pipe, PipeTransform } from '@angular/core';
import { roleDisplayName } from '../../../types/user-role';

/**
 * Shows a role the way people read it ("Superadmin"), whatever spelling the
 * backend sent. Pure: the output depends only on the input.
 */
@Pipe({ name: 'roleLabel' })
export class RoleLabelPipe implements PipeTransform {
  transform(role: string | null | undefined): string {
    return roleDisplayName(role);
  }
}
